var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wxa-usage"}},[_c('guide-share-header',{attrs:{"wxa-page":_vm.wxaPage,"wxa-page-param":_vm.wxaPageParam,"name":'下单流程'}}),_vm._v(" "),_c('new-user-video-box',{attrs:{"video-url":_vm.videoUrl}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf7ecb14","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/guide/newUser/WxaUsage.vue
// module id = null
// module chunks = 